import { Reducer } from "redux";
import LocalStorageManager from "../../services/LocalStorageManager";
import {
    CHANGE_ABLE_TO_SEE_MODIFY_PATIENT_INFO,
    CHANGE_ABLE_TO_SEE_MODIFY_PREFERRED_PHARMACY,
    CHANGE_DISPLAY_PROFILE_PICTURES_DURING_APPOINTMENT_CONFIRMATION_VALUE,
    CHANGE_HEALTHCARD_EXPIRATION_REDIRECT_TO_RECEPTION,
    CHANGE_REGION_CODE_CONFIRMATION_REQUIREMENT,
    UPDATE_LANGUAGE_SELECTION_LIST,
    CHANGE_DEFAULT_LANGUAGE,
    CHANGE_ADMIN_SETTING_NUMBER_FIELD,
    CHANGE_PATIENT_ABLE_BOOK_NEW_APPOINTMENT,
    SELECT_CURRENT_SITE,
    UPDATE_SITE_SELECTION_LIST
} from "./constant";
import {
    ToggleAbleToSeeAndModifyExistingPatientDataStateHandler,
    ToggleAbleToSeeAndModifyExistingPreferredPharmacyStateHandler,
    ToggleDisplayProfilePicturesDuringAppointmentConfirmationHandler,
    ToggleHealthCardExpirationRedirectToReceptionHandler,
    ToggleRegionCodeConfirmationRequiredStateHandler,
    UpdateLanguageSelectionListHandler,
    ChangeAdminSettingNumberFieldHandler,
    TogglePatientAbleToBookNewAppointmentActionHandler,
    ChangeAdminCurrentSiteHandler,
    LoadClinicInformationHandler,
    ChangeDefaultLanguageHandler,
    UpdateSiteSelectionListHandler
} from "./handlers";
import {
    AdminOptionActions,
    AdminOptionsState,
    ToggleAbleToSeeAndModifyExistingPatientDataOptionAction,
    ToggleAbleToSeeAndModifyExistingPreferredPharmacyOptionAction,
    ToggleDisplayProfilePicturesDuringAppointmentConfirmationOptionAction,
    ToggleHealthCardExpirationRedirectToReceptionOptionAction,
    ToggleRegionCodeConfirmationRequiredOptionAction,
    UpdateLanguageSelectionListAction,
    ChangeDefaultLanguageAction,
    ChangeAdminSettingNumberFieldAction,
    TogglePatientAbleToBookNewAppointmentAction,
    SelectCurrentSiteAction,
    UpdateSiteSelectionListAction
} from "./type";
import { LanguageCodes } from "../../constants/languages";
import { LOAD_CLINIC_INFORMATION } from "../ClinicInformation/constants";
import { LoadClinicInformationAction } from "../ClinicInformation/type";

export const DefaultTimeSpan = 16;
export const DefaultInactivityDelay = 20;
export const DefaultLatenessDelay = 20;
export const DefaultMaximumTimeGapBetweenAppointments = 20;
export const DefaultCheckInDelay = 15;

/**
 * @name initialState
 * @type {AdminOptionsState}
 * @description Initial state of this part of the store. At start up, we look at the local storage and prioritize those values.
 */
export const initialState: AdminOptionsState = LocalStorageManager.getAdminOptions() ? LocalStorageManager.getAdminOptions() : {
    ableToSeeAndModifyExistingPatientData: false,
    ableToSeeAndModifyExistingPreferredPharmacy: false,
    regionCodeConfirmationRequired: false,
    showProfilePictureDuringConfirmation: false,
    healthCardExpirationRedirectToReception: false,
    patientAbleToBookNewAppointments: false,
    useableLanguages: new Set<LanguageCodes>([LanguageCodes.French]),
    defaultLanguage: LanguageCodes.French,
    sessionTimeSpan: DefaultTimeSpan,
    inactivityDelay: DefaultInactivityDelay,
    latenessDelay: DefaultLatenessDelay,
    maximumTimeGapBetweenAppointments: DefaultMaximumTimeGapBetweenAppointments,
    checkInDelay: DefaultCheckInDelay,
    siteId: null,
    multiSiteIds: new Set<string>()
};

/**
 * @name reducer
 * @constructs AdminOptionsState
 * @param {AdminOptionsState} state 
 * @param {AdminOptionActions} action 
 */
const reducer: Reducer<AdminOptionsState> = (state: AdminOptionsState = initialState, action: AdminOptionActions) => {
    switch (action.type) {
        case CHANGE_ABLE_TO_SEE_MODIFY_PATIENT_INFO:
            return ToggleAbleToSeeAndModifyExistingPatientDataStateHandler(state, action as ToggleAbleToSeeAndModifyExistingPatientDataOptionAction);

        case CHANGE_ABLE_TO_SEE_MODIFY_PREFERRED_PHARMACY:
            return ToggleAbleToSeeAndModifyExistingPreferredPharmacyStateHandler(state, action as ToggleAbleToSeeAndModifyExistingPreferredPharmacyOptionAction);

        case CHANGE_REGION_CODE_CONFIRMATION_REQUIREMENT:
            return ToggleRegionCodeConfirmationRequiredStateHandler(state, action as ToggleRegionCodeConfirmationRequiredOptionAction);

        case CHANGE_DISPLAY_PROFILE_PICTURES_DURING_APPOINTMENT_CONFIRMATION_VALUE:
            return ToggleDisplayProfilePicturesDuringAppointmentConfirmationHandler(state, action as ToggleDisplayProfilePicturesDuringAppointmentConfirmationOptionAction);

        case CHANGE_HEALTHCARD_EXPIRATION_REDIRECT_TO_RECEPTION:
            return ToggleHealthCardExpirationRedirectToReceptionHandler(state, action as ToggleHealthCardExpirationRedirectToReceptionOptionAction);

        case CHANGE_PATIENT_ABLE_BOOK_NEW_APPOINTMENT:
            return TogglePatientAbleToBookNewAppointmentActionHandler(state, action as TogglePatientAbleToBookNewAppointmentAction);

        case UPDATE_LANGUAGE_SELECTION_LIST:
            return UpdateLanguageSelectionListHandler(state, action as UpdateLanguageSelectionListAction);

        case CHANGE_DEFAULT_LANGUAGE:
            return ChangeDefaultLanguageHandler(state, action as ChangeDefaultLanguageAction);

        case CHANGE_ADMIN_SETTING_NUMBER_FIELD:
            return ChangeAdminSettingNumberFieldHandler(state, action as ChangeAdminSettingNumberFieldAction);

        case SELECT_CURRENT_SITE:
            return ChangeAdminCurrentSiteHandler(state, action as SelectCurrentSiteAction);

        case UPDATE_SITE_SELECTION_LIST:
            return UpdateSiteSelectionListHandler(state, action as UpdateSiteSelectionListAction);

        case LOAD_CLINIC_INFORMATION:
            return LoadClinicInformationHandler(state, action as LoadClinicInformationAction);

        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/AdminOptions/reducer.ts